var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-base text-center"},[_c('vue-apex-charts',{attrs:{"type":"radialBar","height":"350","options":_vm.chartOptions,"series":_vm.theSeries}}),_c('div',{style:({
      backgroundColor: _vm.settings.value.color,
      marginLeft: '60px',
      marginRight: '60px',
      color: 'white', 
      padding: '10px',
      fontWeight:'bold'
    })},[_c('p',[_vm._v("Done: "+_vm._s(_vm.settings.value.counts[0]))]),_c('p',[_vm._v("Pending: "+_vm._s(_vm.settings.value.counts[1]))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }